export enum DynamicFormConfigEntityTypeLegalNameDefaults {
    DRIVER = "Driver",
    DRIVER_COMPANY = "Company",
}
